import React, { lazy } from 'react';

const Dialogs = lazy(() => import('pages/Dialogs/Dialogs'));
const Profile = lazy(() => import('pages/Profile/Profile'));
const Settings = lazy(() => import('pages/Settings/Settings'));
const Gallery = lazy(() => import('pages/Gallery/Gallery'));
const Chat = lazy(() => import('pages/Chat/Chat'));
const Registration = lazy(() => import('pages/Registration/Registration'));
const BlockList = lazy(() => import('pages/BlockList/BlockList'));

export enum PrivatePath {
    dialogs = '/dialogs',
    profile = '/profile',
    settings = '/settings',
    gallery = '/gallery',
    chat = '/chat/:uuid',
    registration = '/registration',
    support = '/chat/0',
    blocklist = '/blocklist',
}

export const privateRoutes = [
    {
        path: PrivatePath.dialogs,
        page: <Dialogs />,
    },
    {
        path: PrivatePath.profile,
        page: <Profile />,
    },
    {
        path: PrivatePath.settings,
        page: <Settings />,
    },
    {
        path: PrivatePath.gallery,
        page: <Gallery />,
    },
    {
        path: PrivatePath.chat,
        page: <Chat />,
    },
    {
        path: PrivatePath.registration,
        page: <Registration />,
    },
    {
        path: PrivatePath.blocklist,
        page: <BlockList />,
    },
];
